/**
 * Insere funcionalidades adicionais nos objetos Form
 *
 * @author Wellington
 * @since 2025-06-29
 * @version 1.0.0
 * @license Comercial
 */

const htmlFormElementExtensions = {
  /**
   * Adiciona uma linha
   */
  clearForm() {
    const elements = this.querySelectorAll("input, textarea, select");
    elements.forEach((el) => {
      const fieldbox = el.closest(".fieldbox");
      el.removeAttribute("data-valid");
      fieldbox?.classList.remove("valid", "invalid");
      el.classList?.remove("valid", "invalid");

      const phoneWrapper = el.closest(".input-wrapper.phone");
      if (phoneWrapper) {
        if (el.type === "hidden") {
          return;
        }

        if (el.dataset?.type === "phone") {
          el.value = "";
          delete el.dataset.rawValue;
          return;
        }
      }

      if (el.tagName === "SELECT") {
        el.selectedIndex = 0;
      } else if (el.type === "checkbox" || el.type === "radio") {
        el.checked = false;
      } else {
        el.value = "";
      }

      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.dispatchEvent(new Event("change", { bubbles: true }));
    });

    const selecteds = this.querySelectorAll(".combo-selected");
    selecteds.forEach((selected) => {
      if (selected.closest(".input-wrapper.phone")) {
        return;
      }

      selected.textContent = dic.labels.select;
      selected.removeAttribute("data-value");
    });
  },
};

/**
 * Adiciona os métodos ao protótipo de HTMLFormElement
 */
const extendHTMLFormElement = () => {
  Object.entries(htmlFormElementExtensions).forEach(([key, value]) => {
    if (!HTMLFormElement.prototype[key]) {
      HTMLFormElement.prototype[key] = value;
    } else {
      console.warn(
        `HTMLFormElement.prototype.${key} já existe e não será sobrescrito.`
      );
    }
  });
};

export default extendHTMLFormElement;
